import { styled } from '../muiReexports';
export const InnerContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2.5),
    alignItems: 'center',
    lineHeight: '1rem',
}));
